module.exports = __webpack_public_path__ + "img/zhangjie.4ab99296.png";